<div class="em-documentation main-content">
    <router-outlet></router-outlet>
</div>